// extracted by mini-css-extract-plugin
module.exports = {"NavItem":"NavItem_NavItem__2STO3","active":"NavItem_active__ykWw2"};